module.exports = __webpack_public_path__ + "img/print_icon.64a67cbd.svg";